import { Component, ViewEncapsulation } from '@angular/core'

@Component({
  selector: 'ftr-link-grid',
  templateUrl: './link-grid.component.html',
  encapsulation: ViewEncapsulation.None,
})
/*
 * Displays a responsive grid of link items. Used on
 * category pages
 */
export class LinkGridComponent {}
